import Base from '../base';
import apiUrls from '../api-urls';

export default class GroupsSettingsApi extends Base {
    async setSportsLimits(data) {
        return this.apiClient.post(apiUrls.backOffice.sportsLimits, data, true);
    }
}